import { render, staticRenderFns } from "./ProductTableRow.vue?vue&type=template&id=3928329e&"
import script from "./ProductTableRow.vue?vue&type=script&lang=ts&"
export * from "./ProductTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports